import type { ParsedVideo } from './media-gallery.types';

const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'];
const RUTUBE_HOSTS = ['rutube.ru', 'www.rutube.ru'];

function safeUrl(raw: string): URL | null {
  try {
    return new URL(raw.trim());
  } catch {
    return null;
  }
}

function extractYoutubeId(url: URL): string | null {
  if (url.hostname === 'youtu.be') {
    const id = url.pathname.replace(/^\/+/, '').split('/')[0];
    return id || null;
  }
  const vParam = url.searchParams.get('v');
  if (vParam) return vParam;
  const segments = url.pathname.split('/').filter(Boolean);
  const idx = segments.findIndex((s) => s === 'embed' || s === 'shorts' || s === 'live');
  if (idx >= 0 && segments[idx + 1]) {
    return segments[idx + 1] ?? null;
  }
  return null;
}

function extractRutubeId(url: URL): string | null {
  const segments = url.pathname.split('/').filter(Boolean);
  const videoIdx = segments.findIndex((s) => s === 'video' || s === 'play');
  if (videoIdx === -1) return null;
  if (
    segments[videoIdx] === 'play' &&
    segments[videoIdx + 1] === 'embed' &&
    segments[videoIdx + 2]
  ) {
    return segments[videoIdx + 2] ?? null;
  }
  if (segments[videoIdx] === 'video' && segments[videoIdx + 1]) {
    return segments[videoIdx + 1] ?? null;
  }
  return null;
}

export function parseVideoUrl(input: string | null | undefined): ParsedVideo | null {
  if (!input) return null;
  const url = safeUrl(input);
  if (!url) return null;

  if (YOUTUBE_HOSTS.includes(url.hostname)) {
    const id = extractYoutubeId(url);
    if (!id) return null;
    return {
      provider: 'youtube',
      videoId: id,
      embedUrl: `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&enablejsapi=1`,
      thumb: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
    };
  }

  if (RUTUBE_HOSTS.includes(url.hostname)) {
    const id = extractRutubeId(url);
    if (!id) return null;
    return {
      provider: 'rutube',
      videoId: id,
      embedUrl: `https://rutube.ru/play/embed/${id}`,
      thumb: `https://rutube.ru/api/video/${id}/thumbnail/?redirect=1`,
    };
  }

  return null;
}
